import type { CommunityMember } from "@circle-react/types";

import type { Person } from "@/react/types/AudienceList";

import { MobileCompassMemberRow } from "../../CompassMemberRow/MobileCompassMemberRow";

export const MobileCommunityMember = ({
  canReceiveDmFromCurrentMember,
  communityMember,
}: {
  canReceiveDmFromCurrentMember: boolean;
  communityMember: Person;
}) => (
  <li
    className="bg-primary border-primary border-b pb-3"
    data-testid="community_member"
  >
    <MobileCompassMemberRow
      iconOnly
      member={communityMember as CommunityMember}
      canReceiveDmFromCurrentMember={canReceiveDmFromCurrentMember}
      showMomentumModal={false}
    />
  </li>
);
